<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Serah Terima Jabatan {{ cabangIdState() }}</h5>
            </template>
            <div class="form-content-wrapper mb-4">
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <div class="d-flex form-content-wrapper mb-4">
                        <b-form-group class="mr-2 mb-0">
                            <b-form-input type="date" v-model="filter.date" v-on:keyup.enter="getItems()" />
                        </b-form-group>
                        <!-- <b-form-group class="mr-2 mb-0">
                            <b-form-input v-model="filter.judul" v-on:keyup.enter="getItems()" placeholder="Search" />
                        </b-form-group> -->

                        <b-button variant="pgiBtn" name="searchTableBtn" @click="getItems()">
                            <b-spinner small class="loading-spinner" v-if="isBusy"></b-spinner>
                            <i class="fa fa-search" v-else></i>
                        </b-button>
                    </div>
                    <div class="mb-4">
                        <b-button v-if="access" variant="pgiBtn"
                            @click="onModalInput()">Input Serah Terima</b-button>
                    </div>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <b-table bordered hover show-empty :busy="isBusy" :items="items" :fields="fields" responsive
                        class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Mengambil data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data.
                        </template>
                        <template v-slot:cell(urutan)="row">
                            <div v-if="row.item.urutan == null" class="text-muted">
                                Tidak Aktif
                            </div>
                            <div v-else class="font-weight-bold">
                                {{ row.item.urutan }}
                            </div>
                        </template>
                        <template v-slot:cell(date)="row">
                            <div>{{ $helper.changeDateFormat(row.item.date) }}</div>
                        </template>
                        <template v-slot:cell(status)="row">

                            <b-badge v-if="row.item.status == 2" variant="success">Diterima</b-badge>

                            <b-badge v-if="row.item.status == 1" variant="warning">Pending</b-badge>
                            <b-badge v-if="row.item.status == 3" variant="danger">Dibatalkan</b-badge>
                            <b-badge v-if="row.item.status == 4" variant="primary">Selesai</b-badge>
                        </template>
                        <template v-slot:cell(aksi)="row">
                            <b-button v-if="row.item.creator.name == activeUser && row.item.status == 1" variant="danger"
                                class="btn btn-sm" @click="onConfirmBatal(row.item)">Batalkan</b-button>
                            <b-button v-if="row.item.receiver.name == activeUser && row.item.status == 1" variant="success"
                                class="btn btn-sm" @click="onModalTerima(row.item)">Terima</b-button>
                            <b-button
                                v-if="row.item.creator.name == activeUser | row.item.sender.name == activeUser && row.item.status == 2"
                                variant="success" class="btn btn-sm mr-2"
                                @click="onModalSelesai(row.item)">Selesaikan</b-button>
                            <b-button
                                v-if="row.item.creator.name == activeUser | row.item.receiver.name == activeUser | row.item.sender.name == activeUser && row.item.status == 2"
                                variant="dark" class="btn btn-sm" @click="getCetakForm(row.item)">Cetak Form</b-button>
                        </template>
                    </b-table>
                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="show" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                            aria-controls="my-table" @input="onPageChange"></b-pagination>
                    </div>
                </div>
            </div>
        </b-card>

        <b-modal id="modal-input" title="Buat Serah Terima" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Menyerahkan jabatan dari kepala unit
            <div class="my-2" v-if="kepalaUnit != null">
                <strong>{{ kepalaUnit.name }}</strong>
            </div>

            <div class="my-2">
                <label>
                    kepada
                </label>
                <multiselect name="gadaiKaratEmas" :internal-search="true" :allow-empty="false" deselect-label=""
                    v-model="input.receiver" :options="optReceiver" :disabled="optReceiver.length == 0" select-label=""
                    label="name" track-by="name" placeholder="-- Please select an option --" />
            </div>

            <div class="my-3">
                <label>
                    Tanggal Efektif
                </label>

                <b-form-group class="mr-2 mb-0">
                    <b-form-input type="date" v-model="input.date" />
                </b-form-group>
            </div>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="onConfirmSubmit()">
                    {{ isSubmitting ? "Memproses..." : "Submit" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="modal-terima" title="Konfirmasi Terima" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Terima serah terima ini ? Role anda akan naik menjadi Kepala Unit setelah logout dan login kembali.

            <b-alert show variant="danger" class="my-2">
                <strong>
                    Perhatian !
                </strong>
                <br>
                Pastikan kanit sedang tidak menggunakan Pugindo, Karena kanit akan otomatis terlog-out setelah menerima
                sertijab!
            </b-alert>

            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="onConfirmTerima()">
                    {{ isSubmitting ? "Memproses..." : "Terima" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="modal-confirm-terima" title="Konfirmasi Terima" centered no-close-on-backdrop no-close-on-esc
            hide-footer>
            <b-row class="mb-2">
                <b-col><iframe v-if="urlCetak != null" width="100%" height="300" :src="$baseFilePath + urlCetak.name"
                        frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
            Silahkan logout dan login kembali untuk mendapatkan role terbaru.
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="didLogout()">
                    {{ isSubmitting ? "Memproses..." : "Logout" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="modal-cetak-form" title="Cetak Form" centered no-close-on-backdrop no-close-on-esc hide-footer>

            <div v-if="isSubmitting">
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </div>
            <b-row class="mb-2">
                <b-col><iframe v-if="cetakForm != null" width="100%" height="300" :src="$baseFilePath + cetakForm.name"
                        frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-selesai" title="Selesaikan Serah Terima" centered no-close-on-backdrop no-close-on-esc
            hide-footer>
            Selesaikan serah terima jabatan ini ? Role anda dan penerima sertijab akan dikembalikan seperti semula!

            <b-alert show variant="danger" class="my-2">
                <strong>
                    Perhatian !
                </strong>
                <br>
                Pastikan user penerima sedang tidak menggunakan Pugindo, Karena user akan otomatis terlog-out setelah
                menerima
                sertijab!
            </b-alert>

            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="onConfirmSelesai()">
                    {{ isSubmitting ? "Memproses..." : "Selesaikan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="modal-confirm-selesai" title="Selesaikan Serah Terima" centered no-close-on-backdrop no-close-on-esc
            hide-footer>
            Serah Terima Jabatan di selesaikan. Silahkan logout dan login kembali!
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="didLogout()">
                    {{ isSubmitting ? "Memproses..." : "Logout" }}
                </b-button>
            </div>
        </b-modal>

        <ModalConfirm id="modal-confirm-input" :isSubmitting="isSubmitting" title="Confirm Input"
            desc="Apakah anda yakin untuk buat serah terima ini?" @submit="onSubmitInput()" />

        <ModalConfirm id="modal-confirm-batal" :isSubmitting="isSubmitting" title="Confirm Batal"
            desc="Apakah anda yakin untuk membatalkan serah terima ini?" @submit="onSubmitBatal()" />
    </div>
</template>

<script>

export default {
    name: 'serah-terima',
    data() {
        return {

            isBusy: false,
            isSubmitting: false,
            show: 1,

            filter: {

                date: null,
                isActive: 0
            },

            activeUser: localStorage.getItem('name'),
            activeRole: localStorage.getItem('role'),
            activeCabang: localStorage.getItem('activeCabang'),
            activeCabangId: localStorage.getItem('activeCabangId'),
            kepalaUnit: null,
            cetakForm: null,
            urlCetak: null,
            input: {
                date: new Date().toLocaleDateString('en-IN'),
                receiver: null,
                urutan: 1
            },

            options: [
                { value: 1, text: '10' },
                { value: 2, text: '20' },
                { value: 3, text: '30' },
                { value: 4, text: '40' },
                { value: 5, text: '50' },
            ],

            fields: [
                { key: `creator.name`, label: "Dibuat Oleh" },
                { key: `sender.name`, label: "Menyerahkan" },
                { key: `receiver.name`, label: "Menerima" },
                { key: "date", label: "Tanggal Efektif" },
                { key: "status", label: "Status" },
                { key: "aksi", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",
            access : false,

            optActiveBanners: [],
            optReceiver: []
        }
    },

    watch: {
        'activeCabangId': function () {
            this.getItems()
        }
    },
    methods: {

        
        cabangIdState() {
            let cabang = JSON.parse(localStorage.getItem('cabang'))
            let idx = cabang.findIndex(item => item.id == this.$store.state.readNotifstore.cabangId)
            this.activeCabangId = cabang[idx].id
            return cabang[idx].name
        },

        getAccess() {
            this.$axios.get("/role-handover/check-if-allowed-to-create").then(res => {
                this.access = res
            })
                .catch(()=> this.access = false)
        },
        getKepalaUnit() {

            this.$axios.get("role-handover/kepala-unit?branchId=" + this.activeCabangId).then(res => {
                this.kepalaUnit = res.data
            })
                .catch(error => this.$helper.parseError(this, error))

        },
        getReceiver() {

            this.$axios.get("role-handover/receiver-selection?branchId=" + this.activeCabangId).then(res => {
                this.optReceiver = res.data
            })
                .catch(error => this.$helper.parseError(this, error))

        },

        async getCetakForm(item) {
            this.isSubmitting = true
            this.$bvModal.show("modal-cetak-form")

            this.$axios.get("role-handover/print?handoverId=" + item.id).then(res => {
                this.cetakForm = res.data
                this.isSubmitting = false
            })
                .catch(error => {
                    this.cetakForm = null
                    this.$bvModal.hide("modal-terima")
                    this.$bvModal.hide("modal-confirm-terima")
                    this.$bvModal.hide("modal-cetak-form")
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                }
                )

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            param += "&branchId=" + this.activeCabangId

            if (!this.$helper.isNullOrEmpty(this.filter.date)) {
                param += "&filterJudul=" + this.filter.date
            }

            if (this.filter.isActive != 0) {
                param += "&filterActive=true"
            }


            return this.$axios.get("/role-handover/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.totalRows + " entri"

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onModalInput() {
            this.resetinput()
            this.$bvModal.show("modal-input")
        },

        onConfirmSubmit() {
            if (this.$helper.isNullOrEmpty(this.input.date)) {
                return this.$helper.toastErr(this, 'Mohon lengkapi data !!!')
            }
            if (this.$helper.isNullOrEmpty(this.input.receiver)) {
                return this.$helper.toastErr(this, 'Mohon lengkapi data !!!')
            }
            this.$bvModal.show("modal-confirm-input")
        },

        onSubmitInput() {
            let payload = new FormData()
            payload.append("branchId", this.activeCabangId)
            payload.append("receiverId", this.input.receiver.id)
            payload.append("date", this.input.date)

            this.isSubmitting = true
            this.$axios.post("role-handover/", payload).then(() => {

                this.$helper.toastSucc(this, 'Data Serah terima berhasil dibuat')

                this.getItems()
                this.$bvModal.hide("modal-input")
                this.$bvModal.hide("modal-confirm-input")

            })
                .catch(error => {
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                }
                )
                .finally(() => this.isSubmitting = false)

        },

        onModalTerima(item) {
            this.activeItem = item
            this.$bvModal.show("modal-terima")
        },

        onModalSelesai(item) {
            this.activeItem = item
            this.$bvModal.show("modal-selesai")
        },

        onConfirmSelesai() {

            this.isSubmitting = true
            this.$axios.post('role-handover/finish?handoverId=' + this.activeItem.id).then(() => {
                this.$bvModal.show("modal-confirm-selesai")
                // this.getItems()
            })
                .catch(error => {
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)

                    this.$bvModal.hide("modal-selesai")
                    this.$bvModal.hide("modal-confirm-selesai")
                }
                )
                .finally(() => this.isSubmitting = false)

            this.$bvModal.show("modal-confirm-selesai")
        },

        async onConfirmTerima() {
            await this.onSubmitTerima()
            // await this.$bvModal.show("modal-confirm-terima")
        },

        async onSubmitTerima() {

            this.isSubmitting = true
            this.$axios.post('role-handover/accept?handoverId=' + this.activeItem.id).then(res => {

                this.urlCetak = res.data
                // this.$bvModal.hide("modal-terima")
                this.$bvModal.show("modal-confirm-terima")
                // this.getItems()
            })
                .catch(error => {
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)

                    this.$bvModal.hide("modal-terima")
                    this.$bvModal.hide("modal-confirm-terima")
                }
                )
                .finally(() => this.isSubmitting = false)

        },

        onConfirmBatal(item) {
            this.activeItem = item
            this.$bvModal.show("modal-confirm-batal")
        },

        onSubmitBatal() {
            this.isSubmitting = true
            this.$axios.post(`role-handover/cancel?handoverId=${this.activeItem.id}`).then(() => {

                this.$helper.toastSucc(this, 'Data Serah terima berhasil dibatalkan')

                this.getItems()
                this.$bvModal.hide("modal-confirm-batal")
            })
                .catch(error => {
                    this.isSubmitting = false
                    this.$helper.parseError(this, error)
                }
                )
                .finally(() => this.isSubmitting = false)
        },

        didLogout() {

            if (this.firebase != null && this.firebase.messaging.isSupported()) {

                // Invalidate token
                let fcmToken = localStorage.getItem("fcmToken")
                if (fcmToken != null) {

                    let payload = new FormData()
                    payload.append("token", fcmToken)
                    this.$axios.post("/user/logout", payload)
                    this.firebase.messaging().deleteToken(fcmToken)

                }

            }

            // Clears localstorage
            this.$axios.defaults.headers.common['Authorization'] = ""
            var version = localStorage.getItem("version")
            localStorage.clear()
            sessionStorage.clear()
            localStorage.setItem("version", version)

            this.$router.push("/login")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        resetinput() {
            this.input = {
                date: new Date().toLocaleDateString('en-CA'),
                receiver: null,
                urutan: 1
            }
        }

    },

    created() {
        this.getItems()
        this.getKepalaUnit()
        this.getReceiver()
        this.getAccess()
    }

}
</script>
